import { render, staticRenderFns } from "./detalleAdminPedido.vue?vue&type=template&id=7f78b278&scoped=true&"
import script from "./detalleAdminPedido.vue?vue&type=script&lang=js&"
export * from "./detalleAdminPedido.vue?vue&type=script&lang=js&"
import style0 from "./detalleAdminPedido.vue?vue&type=style&index=0&id=7f78b278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f78b278",
  null
  
)

export default component.exports